import { createReducer } from 'redux-act';
import uniqBy from 'lodash/unionBy';
// project files
import * as actions from './actions';

const initialState = {
  locationPathname: '',
  locationQuery: {},
  instructors: [],
  user: {},
  users: [],
  topics: [],
  isConcurrentBooking: false,
};

const globalReducer = createReducer(
  {
    [actions.updateGlobalItem]: (state, payload) => ({ ...state, [payload.key]: payload.data }),
    [actions.addToGlobalItem]: (state, payload) => {
      const items = uniqBy([payload.data, ...state[payload.key]], (o) => o._id);
      return {
        ...state,
        [payload.key]: items,
      };
    },
  },
  initialState
);

export default globalReducer;
